/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - React hook for lobby simulation
 */

import type { LobbyMetadata } from "@game/domain";
import { useEffect, useState } from "react";
import type { LobbySimulation } from "../simulation";
import { updateLobbySimulation } from "../simulation";

export const useLobbySimulation = (
  lobby: LobbyMetadata,
  isFirst: boolean,
  lobbiesList: LobbyMetadata[],
): LobbySimulation | null => {
  const [, setSimulationTick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSimulationTick((previous) => previous + 1);
    }, 250);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // Ticking local state keeps lobby-card simulations moving between server updates.
  return updateLobbySimulation(
    lobby.id,
    lobby.playerCount,
    lobby.maxPlayers,
    isFirst,
    lobbiesList,
  );
};
